import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import "./styles.scss";

const Stack = ({ children, className, dashboard, ...props }) => (
  <Container
    {...props}
    className={classNames(
      dashboard ? "mydpd-title-dashboard" : "mydpd-tile-stack",
      className
    )}
  >
    <Row>{children}</Row>
  </Container>
);

Stack.defaultProps = {
  className: "",
  children: null,
  dashboard: false,
};

Stack.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dashboard: PropTypes.bool,
  props: PropTypes.object,
};

export default Stack;
